import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import '../../styling/ProductModal.css';
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';


const CancelMembershipModal = ({ isCancelModalOpen, closeCancelModal, planName, isYearly, nextPaymentDate }) => {
  const [plan, setPlan] = useState(null);
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [feedback, setFeedback] = useState("");

  const date = new Date(nextPaymentDate);
  const formattedDate = date.toLocaleDateString('en-GB');
  const ParaDate = date.toLocaleDateString('en-US', {
  year: 'numeric',
  month: 'long',
  day: '2-digit',
});

  const price = isYearly ? plan?.yearlyCost : plan?.monthlyCost;

  const fetchPlanByName = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/plan/${planName}`, {
        withCredentials: true,
      });
      setPlan(response.data.plan);
    } catch (error) {
      console.error(`Error fetching plan "${planName}":`, error.response?.data || error.message);
    }
  };

  const cancelSubscription = async () => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/cancel-subscription`,
      {}, // request body if needed
      {
        withCredentials: true, // include cookies/session if required
      }
    );

    console.log('Subscription cancelled:', response.data);
    openFeedbackModal();
    
  } catch (error) {
    console.error('Error cancelling subscription:', error.response?.data || error.message);
    throw error;
  }
};

  useEffect(() => {
    if(planName)
    fetchPlanByName();
  }, [planName]);

  if (!plan) return null;

  const openFeedbackModal = () => {
    closeCancelModal(); 
    setIsFeedbackModalOpen(true); 
  };

  const submitFeedback = () => {
    console.log("User Feedback:", feedback);
    setIsFeedbackModalOpen(false);
    setFeedback("");
  };

  const buttonStyle = {
    cursor:'pointer',
    background: 'white',
    border: '1px solid #d9d9d9',
    padding: '10px 20px',
    width: "310px",
    height: "50px",
    fontSize: '15px',
    color: "#080700",
  
  };

  return (
    <>
      {/* --- First Modal: Cancel Membership --- */}
      <Modal
        isOpen={isCancelModalOpen}
        onRequestClose={closeCancelModal}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            transform: 'translate(-50%, -50%)',
            width: '800px',
            height: '80vh',
          },
          overlay: { backgroundColor: 'rgba(0, 0, 0, 0.4)' }
        }}
      >
        <span className="close" onClick={closeCancelModal} style={{ cursor: 'pointer', fontSize: '28px' }}>
          &times;
        </span>
        <h2 style={{ color: "#2a1980" }}>Cancel Your Membership</h2>

        <div style={{
          display: 'flex', gap: '40px', padding: '20px', color: '#1C1154', alignItems: 'flex-start', marginTop: '-10px'
        }}>
          <div style={{ border: '1px solid #d9d9d9', padding: '20px', width: '50%' }}>
            <h2 style={{ color: "#2A1980", marginTop: "-5px" }}>{plan.name}</h2>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
              <h1 style={{ fontSize: '56px', margin: 0 }}>${price}</h1>
              <p style={{ marginLeft: '10px', marginTop: '15px' }}>
                {isYearly ? '/year' : '/month'}<br />
                (billed {isYearly ? 'annually' : 'monthly'})
              </p>
            </div>
            <p style={{ fontSize: '15px', color: '#625C73' }}>Next Billing Date</p>
            <p style={{ fontSize: '15px', color: '#625C73' }}>{formattedDate}</p>
            <p>What's included:</p>
            <ul className='modalUl'>
              {plan.features.map((feature, index) => (
                <li key={index} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                  <IoIosCheckmarkCircleOutline style={{ marginRight: '8px' }} /> {feature}
                </li>
              ))}
            </ul>
            <button style={{
              ...buttonStyle,
              background: 'transparent linear-gradient(90deg, #1C1154 0%, #260F99 100%)',
              color: '#fff',
            }}>
              Current Plan
            </button>
          </div>

          <div style={{ border: '1px solid #d9d9d9', padding: '20px', width: '50%', color: '#625C73' }}>
            <h2 style={{ color: "black", marginTop: "-5px" }}>Cancel Membership</h2>
            <p style={{ fontWeight: 'bold' }}>Your benefits will end on <span>{ParaDate}</span></p>
            <p>You will no longer be charged after this date.</p>
            <p style={{ fontWeight: "bold" }}>Your gallery images will change</p>
            <p>Clients will lose access to photos once your subscription ends.</p>
            <button style={buttonStyle} onClick={cancelSubscription}>Cancel Plan</button>
          </div>
        </div>
      </Modal>

      {/* --- Second Modal: Feedback --- */}
      <Modal
        isOpen={isFeedbackModalOpen}
        onRequestClose={() => setIsFeedbackModalOpen(false)}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            transform: 'translate(-50%, -50%)',
            width: '700px',
            height: '70vh',
          },
          overlay: { backgroundColor: 'rgba(0, 0, 0, 0.4)' }
        }}
      >

        <span className="close" onClick={()=>{setIsFeedbackModalOpen(false)}} style={{ cursor: 'pointer', fontSize: '28px' }}>
          &times;
        </span>

        <h2 style={{ color: "#2a1980", marginBottom: '20px' }}>We're sorry to see you go</h2>
        <p style={{color:'#625C73', fontSize:'15px'}}>Thank you for being a valued member of BoothBloom. We’re constantly striving to improve and proavide the best service possible. Before you leave, we’d love to hear your feedback to understand how we can better meet your needs in the future.</p>
        <p>Write feedback here</p>
        <textarea
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="Your feedback..."
          style={{
            width: '97%',
            height: '100px',
            marginTop: '10px',
            marginBottom: '20px',
            padding: '10px',
            fontSize: '14px',
            borderRadius: '4px',
            border: '1px solid #ccc',
          }}
        />
       <div style={{ textAlign: 'right' }}>
  <button
    onClick={submitFeedback}
    style={{
      padding: '10px 20px',
      backgroundColor: '#2a1980',
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '15px',
      width:'30%'
    }}
  >
    Submit
  </button>
</div>

      </Modal>
    </>
  );
};


export default CancelMembershipModal;